import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../ui/cn';

/**
 * Icon + label row for vertical/horizontal nav menu items (PRO-0540). The icon is
 * decorative (`aria-hidden`); the parent link/button carries the accessible name.
 */
export function NavMenuIconLabel({
  icon: Icon,
  active = false,
  children,
  className,
  iconClassName,
}: {
  icon: LucideIcon;
  active?: boolean;
  children: ReactNode;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <span className={cn('flex min-w-0 items-center gap-3', className)}>
      <Icon
        aria-hidden
        className={cn(
          'h-5 w-5 shrink-0',
          active ? 'text-primary' : 'text-text-secondary',
          iconClassName,
        )}
      />
      <span className="min-w-0 flex-1">{children}</span>
    </span>
  );
}
